
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function ComingSoon() {

  return (
    <div className="min-h-screen bg-white">
      <Header mobileMenuOpen={false} setMobileMenuOpen={() => { }} />

      <main className="pt-24 pb-16">

        <div className="comings">
          <img src="/img/comingsoon.png" alt="" />
        </div>


      </main>

      <Footer />
    </div>
  );
}